import { UserFilter } from "../../types/empresa";
import { DashboardVendedorFiltersValues, EmpresaFiltersData, TipoEmpresa } from "../../types/filter";
import { AvailableEmpresaFilters } from "../../utils/enums";
import { apiSlice } from "../../lib/baseQuery";
import { DataFilterEndpointTags } from "../utils";

const BASE_URL = "/api/filter";

type UserQueryFilter = {
    role: string;
    dealId?: string;
    type: "include" | "exclude";
}

export const dataFilterApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        getUsersForFilter: build.query<UserFilter[], UserQueryFilter>({
            query: (filter: UserQueryFilter) => {
                const queryString = new URLSearchParams(filter).toString();
                return `/api/user/filter?${queryString}`;
            },
            providesTags: [
                DataFilterEndpointTags.GET_USERS_FOR_FILTER,
            ]
        }),
        getFrecuenciaFilterData: build.query<EmpresaFiltersData, AvailableEmpresaFilters[]>({
            query: (filter: AvailableEmpresaFilters[]) => {
                const queryString = new URLSearchParams();
                for (const idx in filter) {
                    queryString.append(`filters`, filter[idx]);
                }
                return {
                    url: BASE_URL + `/empresa?${queryString.toString()}`,
                    method: "GET",
                };
            }
        }),
        getTiposEmpresa: build.query<TipoEmpresa[], void>({
            query: () => BASE_URL + "/tipo-empresa"
        }),
        getTurnos: build.query<TipoEmpresa[], void>({
            query: () => BASE_URL + "/turnos"
        }),
        getTiposVisita: build.query<TipoEmpresa[], void>({
            query: () => BASE_URL + "/tipos-visita"
        }),
        getDashboardVendedoresFilters: build.query<DashboardVendedorFiltersValues, void>({
            query: () => BASE_URL + "/vendedores-dashboard"
        })
    })
});

export const {
    useGetUsersForFilterQuery,
    useGetFrecuenciaFilterDataQuery,
    useGetTiposEmpresaQuery,
    useGetTurnosQuery,
    useGetTiposVisitaQuery,
    useGetDashboardVendedoresFiltersQuery,
} = dataFilterApi;